import { Action, createReducer, on } from '@ngrx/store';
import {
    createProfessionGroupFailure,
    createProfessionGroupSuccessfully,
    deleteProfessionGroupProfession,
    deleteProfessionGroupProfessionSpecialty,
    deleteProfessionGroupProfessionSpecialtySuccessfully,
    deleteProfessionGroupProfessionSuccessfully,
    loadExpertisesByProfIdsFailure,
    loadExpertisesByProfIdsSuccessfully,
    loadRecruiterGroupingFailure,
    loadRecruiterGroupingSuccessfully,
    resetLeadQueueExpertises,
    updateProfessionGroup,
    updateProfessionGroupFailure,
    updateProfessionGroupProfession,
    updateProfessionGroupProfessionSpecialty,
    updateProfessionGroupProfessionSpecialtySuccessfully,
    updateProfessionGroupProfessionSuccessfully,
    updateProfessionGroupSuccessfully,
    loadProfessionGroupAssignedRecruitersFailure,
    loadProfessionGroupAssignedRecruitersSuccessfully,
    updateProfessionGroupPauseStatusesFailure,
    updateProfessionGroupPauseStatusesSuccessfully,
    updateProfessionGroupPauseStatuses,
    loadProfessionGroupIdsWithPausedRecruitersSuccessfully,
    loadProfessionGroupIdsWithPausedRecruitersFailure,
    assignRecruiterToGroup,
    assignRecruiterToGroupFailure,
    unassignRecruiterFromGroup,
    loadRecruiterGrouping,
    unassignRecruiterFromGroupFailure,
    loadProfessionGroupAssignedRecruiters,
    loadProfessionGroupIdsWithPausedRecruiters
} from 'src/app/lead-queue/store/actions/lead-queue.actions';
import { LeadQueueState } from 'src/app/lead-queue/store/state/lead-queue.state';

export const leadQueueInitialState = {
    recruiterGroups: undefined,
    professionGroup: undefined,
    professionGroupRecruiters: undefined,
    professionGroupIdsWithPausedRecruiters: undefined,
    error: undefined,
    expertises: [],
    isLoading: false
} as LeadQueueState;

const reducer = createReducer(
    leadQueueInitialState,

    on(loadRecruiterGrouping, (state, action) => ({
        ...state,
        recruiterGroups: undefined,
        isLoading: true
    })),

    on(loadRecruiterGroupingSuccessfully, (state, action) => ({
        ...state,
        recruiterGroups: action.grouping,
        isLoading: false
    })),

    on(loadRecruiterGroupingFailure, (state, action) => ({
        ...state,
        recruiterGroups: undefined,
        isLoading: false,
        error: action.error
    })),

    on(loadProfessionGroupAssignedRecruiters, (state, action) => ({
        ...state,
        isLoading: true
    })),

    on(loadProfessionGroupAssignedRecruitersSuccessfully, (state, action) => ({
        ...state,
        isLoading: false,
        professionGroupRecruiters: action.professionGroupRecruiters
    })),

    on(loadProfessionGroupAssignedRecruitersFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
        professionGroupRecruiters: undefined
    })),

    on(loadProfessionGroupIdsWithPausedRecruiters, (state, action) => ({
        ...state,
        isLoading: true
    })),

    on(loadProfessionGroupIdsWithPausedRecruitersSuccessfully, (state, action) => ({
        ...state,
        isLoading: false,
        professionGroupIdsWithPausedRecruiters: action.professionGroupIdsWithPausedRecruiters
    })),

    on(loadProfessionGroupIdsWithPausedRecruitersFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
        professionGroupIdsWithPausedRecruiters: undefined
    })),

    on(assignRecruiterToGroup, (state, action) => ({
        ...state,
        recruiterGroups: undefined,
        isLoading: true
    })),

    on(assignRecruiterToGroupFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.error
    })),

    on(unassignRecruiterFromGroup, (state, action) => ({
        ...state,
        isLoading: true
    })),

    on(unassignRecruiterFromGroupFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.error
    })),

    on(updateProfessionGroupPauseStatuses, (state, action) => ({
        ...state,
        isLoading: true
    })),

    on(updateProfessionGroupPauseStatusesSuccessfully, (state, action) => ({
        ...state,
        isLoading: false
    })),

    on(updateProfessionGroupPauseStatusesFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.error
    })),

    on(createProfessionGroupSuccessfully, (state, action) => ({
        ...state,
        error: undefined,
        professionGroup: action.result
    })),

    on(updateProfessionGroup, (state, action) => ({
        ...state,
        error: undefined
    })),

    on(updateProfessionGroupSuccessfully, (state, action) => ({
        ...state,
        error: undefined,
        professionGroup: action.result
    })),

    on(updateProfessionGroupFailure, (state, action) => ({
        ...state,
        error: action.error,
        professionGroup: undefined
    })),

    on(createProfessionGroupFailure, (state, action) => ({
        ...state,
        error: action.error,
        professionGroup: undefined
    })),

    on(loadExpertisesByProfIdsSuccessfully, (state, action) => ({
        ...state,
        expertises: action.expertises,
        error: undefined
    })),

    on(loadExpertisesByProfIdsFailure, (state, action) => ({
        ...state,
        expertises: undefined,
        error: action.error
    })),

    on(updateProfessionGroupProfession, (state, action) => ({
        ...state,
        isLoading: true
    })),

    on(deleteProfessionGroupProfession, (state, action) => ({
        ...state,
        isLoading: true
    })),

    on(updateProfessionGroupProfessionSpecialty, (state, action) => ({
        ...state,
        isLoading: true
    })),

    on(deleteProfessionGroupProfessionSpecialty, (state, action) => ({
        ...state,
        isLoading: true
    })),

    on(updateProfessionGroupProfessionSuccessfully, (state, action) => ({
        ...state,
        isLoading: false
    })),

    on(deleteProfessionGroupProfessionSuccessfully, (state, action) => ({
        ...state,
        isLoading: false
    })),

    on(updateProfessionGroupProfessionSpecialtySuccessfully, (state, action) => ({
        ...state,
        isLoading: false
    })),

    on(deleteProfessionGroupProfessionSpecialtySuccessfully, (state, action) => ({
        ...state,
        isLoading: false
    })),

    on(resetLeadQueueExpertises, (state, action) => ({
        ...state,
        expertises: []
    }))
);

export function leadQueueReducer(state: LeadQueueState | undefined, action: Action) {
    return reducer(state, action);
}
